

























import {Component, Prop, Vue} from 'vue-property-decorator'
import {formatDate} from '@/util/date.util';
import VueGoogleAutocomplete from 'vue-google-autocomplete'

@Component({
  components: {
    VueGoogleAutocomplete
  }
})
export default class FormInput extends Vue {
  @Prop() public value!: string;
  @Prop() public label!: string;
  @Prop() public error!: string;
  @Prop() public type!: string;
  @Prop() public unit!: string;
  @Prop() public min!: Date;
  @Prop() public max!: Date;
  @Prop() public options!: string[];

  public updateValue(value: string) {
    if (this.type === 'date') {
      this.$emit('input', formatDate(new Date(value)));
    } else {
      this.$emit('input', value)
    }
  }

  public formatAddress(address: { route: string; street_number: number; locality: string }): string {
    // eslint-disable-next-line @typescript-eslint/camelcase
    const {route, street_number, locality} = address;
    // eslint-disable-next-line @typescript-eslint/camelcase
    return `${route} ${street_number}, ${locality}`;
  }

  public get getCalendarImg() {
    if (process.env.NODE_ENV === 'development') {
      return require('@/assets/calendar.svg');
    } else {
      return 'https://www.seiringer.at/wp-content/uploads/2021/03/calendar.png';
    }
  }
}
